import { render, staticRenderFns } from "./TemplateRUSClient.vue?vue&type=template&id=d4ed846e&scoped=true&"
import script from "./TemplateRUSClient.vue?vue&type=script&lang=js&"
export * from "./TemplateRUSClient.vue?vue&type=script&lang=js&"
import style0 from "./TemplateRUSClient.vue?vue&type=style&index=0&id=d4ed846e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4ed846e",
  null
  
)

export default component.exports